<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />
<link href='https://fonts.googleapis.com/css?family=Orbitron' rel='stylesheet' type='text/css'>
<div class="container-fluid">
    <ngx-ui-loader [loaderId]="'individual_graph'"></ngx-ui-loader>
    <div class="row" style="margin-right: -12px;">
        <div class="col-md-3" style="padding: 7px;">
            
            <mat-card class="padding">
                <mat-card-content>
                    <ng-select class="custom" [items]="uniqueDeviceId" bindLabel="selectedDevice"
                        placeholder="Device Id" [(ngModel)]="selectedDevice"
                        (change)="getselectedDeviceIddata(selectedDevice)" [clearable]="false"></ng-select>

                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-md-3 " style="padding: 7px;">
          
            <mat-card class="padding">
                <mat-card-content>
                    <ng-select class="custom" [items]="energyMeterIdArray" bindLabel="meterSerialNumber"
                        placeholder="energy Meter Id" [(ngModel)]="selectedEnergyMeter"
                        (change)="getSelectedMeterDetail()" [clearable]="false">
                    </ng-select>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-md-3" style="padding: 7px;">
           
            <mat-card class="padding">
                <mat-card-content>
                    <ng-select class="custom" [items]="parametersList" placeholder="Parameters"
                        [(ngModel)]="selectedParameter" (change)="updateGraphData()"
                        [clearable]="false">
                    </ng-select>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-md-3 " style="padding: 7px;">
           
            <mat-card class="padding">
                <mat-card-content>
                    <ng-select class="custom" [items]="timeOptions" placeholder="Duration"
                        [(ngModel)]="selectedTimeDuration" (change)="updateMeterSelectData()"
                        [clearable]="false">
                    </ng-select>
                </mat-card-content>
            </mat-card>
        </div>

    </div>


    <div class="row " style="padding-left: 7px;">

        <div class="col-md-4 mpadding " style="height:38vh;">

            
            <mat-card style="height:38vh;padding:3px">
                <mat-card-content >
                  <div class="containers">
                    <div class="screen-name row">
                      Power Meter
                    </div>
                    <div class="secondscreens" *ngIf="showInfo === 'first'">
          
                      <div class="screen">
                        <div class="rowl">
                          <div class="lcdisplays">
                            <span id="kWh" [class.blink]="blinkState" #kWhElement>{{totalkwhcurrentmonth}} </span>
                          </div>
                          <span class="unit">kWh</span>
                        </div>
                      </div>
                      
                      
                      
                      <div class="screen">
                        <div class="rowl">
                          <div class="lcdisplays">
                            <span id="kWh" [class.blink]="blinkState" #kWhElement>{{latestkwh_p}}</span>
                          </div>
                          <span class="unit">MkWh</span>
                        </div>
                      </div>
      
      
                      <div class="screen">
                        <div class="rowl">
                          <div class="lcdisplays">
                            <span id="kWh">{{pf}}</span>
                          </div>
                          <span class="unit">Avg.PF</span>
                        </div>
                      </div>
      
                      <div class="screen">
                        <div class="rowl">
                          <div class="lcdisplays">
                            <span id="kWh">{{skVAh}}</span>
                          </div>
                          <span class="unit">kVAh</span>
                        </div>
                      </div>
      
      
                    </div>
                    
                    
                    <div class="secondscreens" *ngIf="showInfo === 'second'">
                      <h6 style=" font-family: 'DigitalFont';margin:0px;font-weight: bold; font-size: 24px;">
                        Voltage
                      </h6>
                      <div class="row">
                        <div class="col-md-6">
                          <div>
                          <a style=" font-family: 'DigitalFont';
                              font-weight: bold;
                              font-size: 21px;
                              margin-right: 116px;"> 1 </a>
                              </div>
                              <div>
                          <a style=" font-family: 'DigitalFont';
                              font-weight: bold;
                              font-size: 21px;
                              margin-right: 116px;"> 2 </a></div>
                            <div>
                         <a style=" font-family: 'DigitalFont';
                               font-weight: bold;
                               font-size: 21px;
                               margin-right: 116px;"> 3 </a>
                               </div>
                        </div>
                        <div class="col-md-6">
                          <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 21px;
                           
                           "> 0 </a> <br>
                          <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 21px;
                           
                           "> 0 </a> <br>
                          <a style=" font-family: 'DigitalFont';
                             font-weight: bold;
                             font-size: 21px;
                            
                            "> 0 </a>
                        </div>
                      </div>
                    </div>
                    <div class="secondscreens" *ngIf="showInfo === 'third'">
                  
                      <h6 style=" font-family: 'DigitalFont';margin:0px;font-weight: bold; font-size: 24px;">
                        {{countstepno}} &nbsp; Current &nbsp; {{lastUpdateDate}}
                      </h6>
                      <div class="row">
                        <div class="col-md-6">
                          <div>
                          <a style=" font-family: 'DigitalFont';
                              font-weight: bold;
                              font-size: 21px;
                              margin-right: 116px;"> I1 </a>
                              </div>
                              <div>
                          <a style=" font-family: 'DigitalFont';
                              font-weight: bold;
                              font-size: 21px;
                              margin-right: 116px;"> I2 </a></div>
                            <div>
                         <a style=" font-family: 'DigitalFont';
                               font-weight: bold;
                               font-size: 21px;
                               margin-right: 116px;"> I3 </a>
                               </div>
                        </div>
                        <div class="col-md-6">
                          <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 21px;
                           
                           ">{{current_l1}} </a> <br>
                          <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 21px;
                           
                           "> {{current_l2}} </a> <br>
                          <a style=" font-family: 'DigitalFont';
                             font-weight: bold;
                             font-size: 21px;
                            
                            "> {{current_l3}} </a>
                        </div>
                      </div>
                    </div>
      
                    <div class="secondscreens" *ngIf="showInfo === 'fourth'">
                      <h6 style=" font-family: 'DigitalFont';margin:0px;font-weight: bold; font-size: 24px;">
                        Avg. PF 
                      </h6>
                      <div class="row">
                      
                        <div >
                          <a style=" font-family: 'DigitalFont';
                            font-weight: bold;
                            font-size: 27px;
                           text-align: center;
                           "> {{pf}} </a> <br>
                         
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-top: 11px; margin-bottom: 7px;">
                      <div *ngIf="showInfo === 'third'">
                        <button style="background-color: #14721F; height: 24px; " (click)="lastfive()">
                          <i class="fas fa-chevron-left" style="color: black;"></i>
                      </button>
                      </div>
                      <div *ngIf="showInfo === 'second'">
                        <button style="background-color: #14721F; height: 24px; " (click)="lastfive()">
                          <i class="fas fa-chevron-left" style="color: black;"></i>
                      </button>
                      </div>
      
                      <button style="background-color: #14721F; height: 24px;margin-left: 30px;" (click)="incrementkwh()">
                        <i class="fas fa-angle-up" style="color: black;"></i>
                      </button>
                      <button style="background-color: #14721F; height: 24px; margin-left: 30px;" (click)="showcurrent()">
                        <i class="fas fa-angle-down" style="color: black;"></i>
                      </button>
                      <button style="background-color: #14721F; height: 24px; margin-left: 30px;" (click)="resetkwhreset()">
                        <i class="fas fa-sync-alt" style="color: black;"></i>
                      </button>
                     
                    
                    
                    </div>
                  </div>
                    
                    <div class="row" style="color: black;">
                        <div class="col-md-12" #energyconsumption_graph></div>
                    </div>
          

                </mat-card-content>
            </mat-card>

        </div>

        <div class="col-md-8 mpadding"  >
             
            <mat-card style="height: 38vh;">
              <mat-card-content>
                <ngx-ui-loader [loaderId]="'individual_graph_ems'"></ngx-ui-loader>
                <div class="col-md-12 graph-container" style="height: 36vh;" #individual_graph>
              
                </div>
              </mat-card-content>
            </mat-card>
            </div>
            </div>
          <div class="row " style="padding: 3px;">
            <div class=" col-md-6 " style="padding: 3px;">
            <mat-card  style="height: 40vh;padding: 0px;">
                <mat-card-header style="background-color:red;">
                    <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;float: left;">Todays Alerts</b>
                </mat-card-header>
                <mat-card-content style="height: 36vh;overflow: auto;scroll-behavior: smooth;padding-right: 3px;padding-left: 3px;padding-bottom: 3px;">
                    <ng-container  >
                        <table class="alerts-table" id="alerttabledata"  >
                            <thead >
                              <tr style=" width: fit-content;  position: sticky;">
                                <th>Date</th>
                                <th>Time</th>
                                <th>Parameter</th>
                                <th>Location</th>
                                <th>Actual Value</th>
                                <th>Threshold Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  class="scrolling-text" *ngFor="let arr of LiveAlertsArray.slice().reverse()">
                                <td >{{ arr.date }}</td>
                                <td>{{ arr.time }}</td>
                                <td>{{ arr.parametername.replace('ap', '') }}</td>
                                <td>{{ arr.sitename }}</td>
                                <td style="text-align: center;">{{ arr.actualvalue}}</td>
                                <td style="text-align: center;">{{arr.thresholdvalue }}</td>
                              </tr>
                            </tbody>
                          </table>
                    </ng-container>
                </mat-card-content>
              </mat-card>
              </div>
              <div class="col-md-6" style="padding: 3px;">
              <mat-card  style="overflow: hidden;overflow-y: scroll;height: 40vh;width:100%;padding: 0px;">
                <mat-card-header style="background-color:red;position: sticky;z-index: 1;">
                    <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;float: left;">Suggestions</b>
                    <button class="speaker-button" (click)="toggleSpeaker()">
                        <i class="fas" [ngClass]="speakerOn ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                      </button>
                </mat-card-header>
                <mat-card-content>
                  <div  *ngIf="!muteSuggestions" (mouseover)="stopAnimations()" (mouseout)="startAnimations()">
                    <ul  [ngClass]="{'suggestionlists': animationRunnings}">
                      <li class="suggestion-item" >
                        <h4 class="suggestion-heading">{{ getPowerFactorHeading() }}</h4>
                        <span class="suggestion-content">{{ getPowerFactorSuggestion() }}</span>
                      </li>
                    </ul>
                  </div>
                  
                </mat-card-content>
              </mat-card>
              </div>
            </div>
</div>